import { Navigate, Outlet, useMatch } from "react-router-dom";
import { useSettings } from "../../hooks/settingHooks";

interface Props {
  config: string;
}

export function ProccessSettings(props: Props) {
  const { config } = props;
  const { data: settings } = useSettings(config);
  const matched = useMatch(`/${config}/app/*`);
  const matchedAdmin = useMatch(`/${config}/admin/*`);

  return (
    <>
      {settings && !matched && !matchedAdmin && <Navigate to="app/layers" />}
      {settings && <Outlet context={{ settings, config }} />}
    </>
  );
}
